import { GenericCallCard } from './chunk-73NDB3QK.js';
import { ProtocolIcon } from './chunk-WMBYYAYI.js';
import { ERC4337, ERC4337_COMPONENTS, ERC4337_EVENTS, ERC4337_CALLS, pickField, ERC4337_FIELDS, ERC4337_LABELS, ProtocolValue, SectionCard, FactGrid, ProtocolParamList, ProtocolBadge } from './chunk-KRDPBEWT.js';
import { AlertTriangle, UserCog } from 'lucide-react';
import { jsx, jsxs } from 'react/jsx-runtime';

var FAIL_CHIP = "inline-flex items-center gap-1 rounded-full border border-warning/40 bg-warning/10 px-2 py-0.5 text-2xs font-medium";
function isZeroAddress(value) {
  return typeof value === "string" && /^0x0{40}$/i.test(value);
}
function reverted(value) {
  if (value === false) return true;
  return typeof value === "string" && value.trim().toLowerCase() === "false";
}
function Erc4337UserOperation({
  event,
  hint,
  chain,
  renderAddress
}) {
  const pid = hint.protocolId ?? ERC4337.protocolId;
  const account = pickField(event.params, ERC4337_FIELDS.sender);
  const paymaster = pickField(event.params, ERC4337_FIELDS.paymaster);
  const success = pickField(event.params, ERC4337_FIELDS.success);
  const gasCost = pickField(event.params, ERC4337_FIELDS.actualGasCost);
  const opHash = pickField(event.params, ERC4337_FIELDS.userOpHash);
  const nonce = pickField(event.params, ERC4337_FIELDS.nonce);
  const failed = reverted(success);
  const sponsored = paymaster != null && !isZeroAddress(paymaster);
  const address = (value) => typeof value === "string" && renderAddress ? renderAddress(value, { chain }) : /* @__PURE__ */ jsx(ProtocolValue, { value });
  const facts = [
    { label: ERC4337_LABELS.account, value: address(account), when: account },
    {
      label: ERC4337_LABELS.paidBy,
      value: sponsored ? address(paymaster) : /* @__PURE__ */ jsx("span", { children: ERC4337_LABELS.selfFunded }),
      when: paymaster != null
    },
    { label: ERC4337_LABELS.entryPoint, value: address(event.address), when: event.address },
    { label: ERC4337_LABELS.gasCost, value: /* @__PURE__ */ jsx(ProtocolValue, { value: gasCost }), when: gasCost != null },
    { label: ERC4337_LABELS.nonce, value: /* @__PURE__ */ jsx(ProtocolValue, { value: nonce }), when: nonce != null },
    { label: ERC4337_LABELS.userOpHash, value: /* @__PURE__ */ jsx(ProtocolValue, { value: opHash }), when: opHash }
  ];
  return /* @__PURE__ */ jsxs(
    SectionCard,
    {
      title: /* @__PURE__ */ jsxs("span", { className: "inline-flex items-center gap-2", children: [
        /* @__PURE__ */ jsx(ProtocolIcon, { protocolId: pid, icon: UserCog }),
        /* @__PURE__ */ jsx("span", { className: "text-sm font-semibold", children: hint.label ?? "Smart account operation" })
      ] }),
      protocolId: pid,
      meta: /* @__PURE__ */ jsxs("span", { className: "inline-flex items-center gap-2", children: [
        failed && /* @__PURE__ */ jsxs(
          "span",
          {
            className: FAIL_CHIP,
            title: "The operation reverted. The transaction still succeeded \u2014 the EntryPoint catches the revert so the bundler is paid.",
            children: [
              /* @__PURE__ */ jsx(AlertTriangle, { className: "size-3", "aria-hidden": true }),
              "Operation reverted"
            ]
          }
        ),
        /* @__PURE__ */ jsx(ProtocolBadge, { protocolId: pid })
      ] }),
      children: [
        /* @__PURE__ */ jsx(FactGrid, { facts }),
        /* @__PURE__ */ jsxs("details", { className: "mt-3 min-w-0", children: [
          /* @__PURE__ */ jsx("summary", { className: "cursor-pointer text-xs text-muted-foreground hover:text-foreground", children: "All event fields" }),
          /* @__PURE__ */ jsx("div", { className: "pt-2", children: /* @__PURE__ */ jsx(ProtocolParamList, { params: event.params, emptyLabel: "No decoded fields" }) })
        ] })
      ]
    }
  );
}

// src/protocols/erc4337/index.ts
var PID = ERC4337.protocolId;
var C = ERC4337_COMPONENTS;
var ERC4337_HINTS = {
  valueHints: [],
  callHints: [
    {
      protocolId: PID,
      call: ERC4337_CALLS.handleOps,
      component: C.handleOps,
      summaryFields: []
    }
  ],
  eventHints: [
    {
      protocolId: PID,
      event: ERC4337_EVENTS.userOperationEvent,
      component: C.userOperation,
      summaryFields: []
    }
  ]
};
function registerErc4337(registry) {
  registry.registerEvent(C.userOperation, Erc4337UserOperation);
  registry.registerCall(C.handleOps, GenericCallCard);
  registry.registerHints(ERC4337_HINTS);
  return registry;
}

export { ERC4337_HINTS, Erc4337UserOperation, registerErc4337 };
//# sourceMappingURL=chunk-JTVUZ4OK.js.map
//# sourceMappingURL=chunk-JTVUZ4OK.js.map